import { immer } from "zustand/middleware/immer";
import { create } from "zustand";

import { CommandPaletteStore } from "./types";

const useCommandPaletteStore = create<CommandPaletteStore>()(
  immer((set) => ({
    isModalOpen: false,
    searchQuery: "",
    activeActionId: undefined,
    activeActionSource: undefined,
    isKeyboardNavigating: false,
    buckets: [],
    currentView: "main",
    subListItems: [],
    subListView: "",
    subListQuery: "",
    breadcrumb: [],

    setModalOpen: (isModalOpen) =>
      set((state) => {
        state.isModalOpen = isModalOpen;
        if (!isModalOpen) {
          state.activeActionId = undefined;
          state.activeActionSource = undefined;
          state.isKeyboardNavigating = false;
          state.searchQuery = "";
          state.currentView = "main";
          state.subListItems = [];
          state.subListView = "";
          state.subListQuery = "";
          state.breadcrumb = [];
        }
      }),

    setSearchQuery: (searchQuery) =>
      set((state) => {
        state.searchQuery = searchQuery;
        state.activeActionId = undefined;
        state.activeActionSource = undefined;
      }),

    setActiveActionId: (actionId, source) =>
      set((state) => {
        state.activeActionId = actionId;
        state.activeActionSource = source;
        if (source === "keyboard") {
          state.isKeyboardNavigating = true;
        }
      }),

    setIsKeyboardNavigating: (isKeyboardNavigating) =>
      set((state) => {
        state.isKeyboardNavigating = isKeyboardNavigating;
      }),

    setBuckets: (buckets) =>
      set((state) => {
        state.buckets = buckets;
      }),

    setSubListItems: (items, breadcrumb) =>
      set((state) => {
        state.subListItems = items;
        state.breadcrumb = breadcrumb;
        state.currentView = "sub-list";
        state.activeActionId = undefined;
      }),

    setSubList: (view, breadcrumb, initialQuery) =>
      set((state) => {
        state.subListView = view;
        state.breadcrumb = breadcrumb;
        state.subListQuery = initialQuery;
        state.currentView = "sub-list";
        state.activeActionId = undefined;
      }),

    setSubListQuery: (query) =>
      set((state) => {
        state.subListQuery = query;
        state.activeActionId = undefined;
      }),

    clearSubList: (fullClear) =>
      set((state) => {
        state.currentView = "main";
        state.subListItems = [];
        state.subListView = "";
        state.subListQuery = "";
        if (fullClear) {
          state.searchQuery = "";
        }
        state.breadcrumb = [];
        state.activeActionId = undefined;
      }),
  }))
);

export default useCommandPaletteStore;
